export const formatRupiah = (money: number) => {
	return new Intl.NumberFormat("id-ID", {
		style: "currency",
		currency: "IDR",
		minimumFractionDigits: 0,
	})
		.format(money)
		.replace(/\s+/g, "");
};

export const formatThousand = (val: any) => {
	return Number(val.replaceAll(".", "")).toLocaleString().replaceAll(",", ".");
};
